<template>
    <div
        id="show-my-slide"
        ref="container"
        style="height: 100% !important; width: 100%; overflow-y: hidden; background-color: #ffffff;"
    >

        <v-carousel
            v-if="semSlideParaDigiplayer"
            cycle
            height="100%"
            hide-delimiter-background
            :show-arrows="false"
        >
            <v-carousel-item
                v-for="(slide, i) in slides"
                :key="i"
            >
                <v-sheet
                    :color="colors[i]"
                    :height=windowHeight
                >
                    <v-row
                        class="fill-height"
                        align="center"
                        justify="center"
                    >
                        <div class="display-2">
                            {{ slide }}
                        </div>
                    </v-row>
                </v-sheet>
            </v-carousel-item>
        </v-carousel>


        <!--v-model="currentSlide" isto estava desformatando os cartazes, por isso foi removido-->
        <!--:interval="(this.$store.state.timelineStore.tempoExibicao * 1000)"-->
        <!--    cycle-->
        <!--    {{slidesUpdatedAt}}-->
        <!--    {{currentSlideIndex}}-->
        <v-carousel
            v-if="!semSlideParaDigiplayer"
            v-model="currentSlideIndex"
            :key="slidesUpdatedAt"
            :interval="(this.$store.state.timelineStore.tempoExibicao * 1000)"
            cycle
            hide-delimiters
            hide-delimiter-background
            :show-arrows="false"
            height="100%"
        >
            <v-carousel-item
                v-for="(item, k) in $store.state.timelineStore.itens"
                :key="k"
                :value="k"
                style="height: 100%; width: 100%;"
            >
                <v-sheet
                    :height=windowHeight
                    :width=windowWidth
                >
                    <Layout1
                        exibindo-em="player"
                        :quadro-atual-loop="item"
                        :current-slide-index="currentSlideIndex"
                    ></Layout1>
                </v-sheet>
            </v-carousel-item>
        </v-carousel>

        <!--        </v-col>-->
    </div>
</template>

<script>
import Layout1 from "./timeline/layouts/layout1";
import Layout2 from "./timeline/layouts/layout2";
import Layout3 from "./timeline/layouts/layout3";

export default {
    components: {Layout3, Layout2, Layout1},

    data() {
        return {
            windowHeight: 0,
            windowWidth: 0,

            semSlideParaDigiplayer: false,
            currentSlideIndex: 0,
            tempoExibicao: 0,
            loading: false,
            updateCounter: 0,
            slidesUpdatedAt: '0',

            colors: [
                'warning',
                'pink darken-2',
                'indigo',
                'red lighten-1',
                'deep-purple accent-4',
                'green darken-2',
            ],
            slides: [
                'digitab.com.br - Mídia digital interna',
                'Sem conteúdo para este display',
                'digitab.com.br - Mídia digital interna',
                'Sem conteúdo para este display',
                'digitab.com.br - Mídia digital interna',
                'Sem conteúdo para este display',
            ],
        }
    },

    created() {
        this.$store.commit('setModoExibicaoSlides', 'player');
    },

    mounted() {
        this.toggleBodyClass('addClass', 'invisible-scrollbar');

        this.windowHeight = window.innerHeight;
        this.windowWidth = window.innerWidth;

        this.$store.commit('setTimelineMainContainerSize', {
            w: window.innerWidth,
            h: window.innerHeight,
        });

        this.getFromApi();
        this.getFromApiInterval();
    },

    methods: {
        getFromApiInterval() {
            // let interval = 10000;
            let interval = 600000; //10 minutos
            setInterval(() => {
                // this.$router.go();
                this.getFromApi();
            }, interval)
        },
        getFromApi() {
            this.loading = true;

            console.log(this.$route.params.uid);

            //veio do app
            if (this.$route.params.uid == 0) {

                // pega vlrs vindos na URL da webview
                let playerId = this.$route.query["player-id"];
                let instalationUUID = this.$route.query["instalation-uuid"];

                axios.get(`/show-my-slides/0?player-id=${playerId}&instalation-uuid=${instalationUUID}`).then(
                    async (response) => {
                        let resp = response.data;

                        if (typeof resp.filial_id != 'undefined') {
                            this.updateCounter++;
                            this.semSlideParaDigiplayer = false;
                            let filialId = resp.filial_id;
                            this.$store.commit('showMySlide/setMyFilialId', filialId);
                            this.$store.commit('showMySlide/setMyUid', this.$route.params.uid);

                            let updatedAt = resp.updated_at;
                            let json = JSON.parse(resp.json);
                            json.id = resp.id;

                            let itensLenght = Object.keys(json.itens).length;

                            let itemLoadedElementsCounter = 0;
                            if(itensLenght > 0){
                                for (const itensKey in json.itens) {
                                    // so faz a proxima iteracao depois de ter carregado os dados da atual
                                    await this.getElementos(json.itens[itensKey]);

                                    itemLoadedElementsCounter++;

                                    if (this.updateCounter === 1) {
                                        // ja exibe os dados na tela quando os dados do primeiro quadro estiverem sido carregados
                                        this.$store.commit('setTimelineState', json);
                                        this.slidesUpdatedAt = updatedAt;
                                        console.log('carregou elementos do item primeira vez');
                                    } else {
                                        // só recarrega o json depois de todos os elementos de todos os itens terem sido carregados
                                        if (itemLoadedElementsCounter === itensLenght) {
                                            // this.$store.commit('resetTimelineState');
                                            this.$store.commit('setTimelineState', json);
                                            this.slidesUpdatedAt = updatedAt;
                                            console.log('carregou elementos do item outras vezes');
                                        }
                                    }
                                }
                            }else{
                                //@todo-later neste caso é interessante exibir propaganda do digitab
                                this.$store.commit('setTimelineState', json);
                            }
                        } else {
                            this.semSlideParaDigiplayer = true;
                        }
                    }, (error) => {
                        console.log(error);
                    }).catch(error => {
                    console.log(error)
                    // this.errored = true
                }).finally(() => this.loading = false);
            } else {
                axios.get('/show-my-slides/' + this.$route.params.uid).then(
                    async (response) => {
                        let resp = response.data;

                        if (typeof resp.filial_id != 'undefined') {
                            this.updateCounter++;
                            this.semSlideParaDigiplayer = false;
                            let filialId = resp.filial_id;
                            this.$store.commit('showMySlide/setMyFilialId', filialId);
                            this.$store.commit('showMySlide/setMyUid', this.$route.params.uid);

                            let updatedAt = resp.updated_at;
                            let json = JSON.parse(resp.json);
                            json.id = resp.id;

                            let itensLenght = Object.keys(json.itens).length;

                            let itemLoadedElementsCounter = 0;
                            if(itensLenght > 0){
                                for (const itensKey in json.itens) {
                                    // so faz a proxima iteracao depois de ter carregado os dados da atual
                                    await this.getElementos(json.itens[itensKey]);

                                    itemLoadedElementsCounter++;

                                    if (this.updateCounter === 1) {
                                        // ja exibe os dados na tela quando os dados do primeiro quadro estiverem sido carregados
                                        this.$store.commit('setTimelineState', json);
                                        this.slidesUpdatedAt = updatedAt;
                                        console.log('carregou elementos do item primeira vez');
                                    } else {
                                        // só recarrega o json depois de todos os elementos de todos os itens terem sido carregados
                                        if (itemLoadedElementsCounter === itensLenght) {
                                            // this.$store.commit('resetTimelineState');
                                            this.$store.commit('setTimelineState', json);
                                            this.slidesUpdatedAt = updatedAt;
                                            console.log('carregou elementos do item outras vezes');
                                        }
                                    }
                                }
                            }else{
                                //@todo-later neste caso é interessante exibir propaganda do digitab
                                this.$store.commit('setTimelineState', json);
                            }
                        } else {
                            this.semSlideParaDigiplayer = true;
                        }
                    }, (error) => {
                        console.log(error);
                    }).catch(error => {
                    console.log(error)
                    // this.errored = true
                }).finally(() => this.loading = false);
            }
        },

        // retorna uma promise
        getElementos(item) {
            //keys: itens > layoutDivisoes > 1 > meioElementos
            let meioElementos = item.layoutDivisoes[1].configs.meioElementos;
            let aAxiosCalls = meioElementos.map((el) => {
                if (el.tipo == 'mercadoria') {

                    if (this.$route.params.uid == 0) {
                        // pega vlrs vindos na URL da webview
                        let playerId = this.$route.query["player-id"];

                        return axios.get(
                            '/show-my-slides/' +
                            '0' +
                            '/mercadorias/' +
                            el.conteudo +
                            `?player-id=${playerId}`,
                            {params: []}
                        ).then((response) => {
                            this.loading = false;
                            let resp = response.data;
                            el.mercDataAux.codigo = resp.codigo;

                            el.mercDataAux.descricao = resp.descricao;
                            el.mercDataAux.preco = resp.preco;
                        });
                    }else{
                        return axios.get(
                            '/show-my-slides/' +
                            this.$route.params.uid +
                            '/mercadorias/' +
                            el.conteudo,
                            {params: []}
                        ).then((response) => {
                            this.loading = false;
                            let resp = response.data;
                            el.mercDataAux.codigo = resp.codigo;

                            el.mercDataAux.descricao = resp.descricao;
                            el.mercDataAux.preco = resp.preco;
                        });
                    }
                }

                if (el.tipo == 'tabela-preco') {
                    if (this.$route.params.uid == 0) {
                        // pega vlrs vindos na URL da webview
                        let playerId = this.$route.query["player-id"];

                        return axios.get(
                            '/show-my-slides/' +
                            '0' +
                            '/tabelas-precos/' +
                            el.conteudo +
                            '/itens' +
                            `?player-id=${playerId}`
                        ).then((response) => {
                            el.tabelaPrecoDataAux.updated_at = '';
                            el.tabelaPrecoDataAux.nome = response.data.header.nome;
                            el.tabelaPrecoDataAux.items = response.data.items;
                        });
                    }else{
                        return axios.get(
                            '/show-my-slides/' +
                            this.$route.params.uid +
                            '/tabelas-precos/' +
                            el.conteudo +
                            '/itens'
                        ).then((response) => {
                            // this.nome = response.data.header.nome;
                            // this.items = response.data.items;

                            el.tabelaPrecoDataAux.updated_at = '';
                            el.tabelaPrecoDataAux.nome = response.data.header.nome;
                            el.tabelaPrecoDataAux.items = response.data.items;
                        });
                    }
                }

                return false;
            });

            return axios.all(aAxiosCalls).then((results) => {
                //chama todos os endpoints do quadro do slide paralelamente
                this.loading = false;
            });
        },

        toggleBodyClass(addRemoveClass, className) {
            const el = document.body;

            if (addRemoveClass === 'addClass') {
                el.classList.add(className);
            } else {
                el.classList.remove(className);
            }
        },
    }
}
</script>

<style scoped>
</style>
